export enum DeploymentSizes  {
    Basic = 'Basic',
    Standard = 'Standard',
    Enterprise = 'Enterprise',
    Custom = 'Custom'
  }
